import React from 'react';
import { Row, Col } from 'bootstrap';
import TrackingSelector from 'main/components/show/cuesheet.prompter/trackingSelector';
import FullScreenCuesheetActions from 'flux/actions/cuesheet.fullscreen/FullScreenCuesheetActions';
import RouteActions from 'flux/actions/RouteActions';
import UserActions from 'flux/actions/UserActions';
import s3 from 'shared/constants/s3';

import { displayView } from 'shared/constants/Onboarding';

// NOTE THIS FILE HAS MANY PROP TYPE VIOLATIONS
// AND ALL ARE DISABLED BY THE COMMENT BELOW.
/* eslint-disable react/prop-types */

const { displayViewSelectShowCaller } = displayView;

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillReceiveProps(nextProps) {
    // When show is being tracked and user switches to Display View for the first
    // time, carry over tracking settings and remove onboarding message to select a user to track
    if (nextProps.enableTracking && !nextProps.trackingEnabled) {
      FullScreenCuesheetActions.toggleTrackingEnabled();
    }
  }

  render() {
    const trackingCols = { lg: 12, md: 12, sm: 12, xs: 14 };

    const {
      trackingEnabled,
      trackableUsers,
      trackedUserId,
      eventId,
      teamId,
      showOnboarding,
      userId,
    } = this.props;

    const onboardingNode = showOnboarding ? (
      <div className="onboarding-wrapper">
        <div className="text-wrapper">
          <div className="title">Select the Show Caller below</div>
          <div className="description">
            A Show Caller is required for this view to function. If you don’t
            have a Show Caller, you can set one on your event’s{' '}
            <a onClick={() => RouteActions.goToEventCrew({ teamId, eventId })}>
              crew page
            </a>
            .
          </div>
        </div>
        <img
          className="onboarding-arrow"
          src={s3.onboardingArrow}
          alt="onboarding-arrow"
        />
      </div>
    ) : null;

    // const text = 'Heads up! This is a free trial of Display View. Learn more about ';

    return (
      <footer id="display-view-footer">
        <Row className="display-view-footer-row">
          <Col {...trackingCols}>
            <TrackingSelector
              onToggleTrackingEnabled={() => {
                if (showOnboarding) {
                  UserActions.updateOnboarding(
                    userId,
                    displayViewSelectShowCaller,
                    true,
                  );
                }
                FullScreenCuesheetActions.toggleTrackingEnabled();
              }}
              onSelectTrackableUser={(id) => {
                if (showOnboarding) {
                  UserActions.updateOnboarding(
                    userId,
                    displayViewSelectShowCaller,
                    true,
                  );
                }
                FullScreenCuesheetActions.selectTrackableUser(id);
              }}
              trackingEnabled={trackingEnabled}
              trackableUsers={trackableUsers}
              trackedUserId={trackedUserId}
            >
              {onboardingNode}
            </TrackingSelector>
          </Col>
        </Row>
      </footer>
    );
  }
}

export default Footer;
